import { render, staticRenderFns } from "./OrderNotesForm.vue?vue&type=template&id=b5dec4c2"
import script from "./OrderNotesForm.vue?vue&type=script&lang=js"
export * from "./OrderNotesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports